import React from "react"
import {
  FormErrorMessage,
  FormControl,
  FormLabel,
  InputLeftElement,
  InputGroup,
  Input,
} from "@chakra-ui/react"
import { Icon } from "../"

export default function FormEmail({ register, success, error }) {
  return (
    <FormControl isInvalid={error}>
      <FormLabel htmlFor="email">Email *</FormLabel>
      <InputGroup>
        <InputLeftElement
          pointerEvents="none"
          children={<Icon name="emailAt" color="primary.200" />}
        />
        <Input
          {...(success && { pointerEvents: "none" })}
          {...register("email", {
            required: {
              value: true,
              message: "Please provide an email address",
            },
            pattern: {
              value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: "Invalid email address",
            },
          })}
        />
      </InputGroup>
      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </FormControl>
  )
}
